import RestoreFromTrashRoundedIcon from "@material-ui/icons/RestoreFromTrashRounded";
import { Snackbar } from "@material-ui/core";
import { Alert } from "@material-ui/lab";

import { useEffect, useState } from "react";

import { useNavigate } from "react-router-dom";
import UtilsFormule from "../../utils/UtilsFormule";
import RateService from "../../services/RateService";
import getCurrentUserId from "../../reduxSaga/sagas/requests/currentUserId";
const AllRates = () => {
  const navigate = useNavigate();

  const [availableRates, setAvailableRates] = useState();
  const [archivedRates, setArchivedRates] = useState();
  const [openErrorAlert, setOpenErrorAlert] = useState(false);
  const [errorAlertText, setErrorAlertText] = useState();
  const [openSuccessAlert, setOpenSuccessAlert] = useState(false);
  const [successAlertText, setSuccessAlertText] = useState();
  const [search, setSearch] = useState("");
  useEffect(() => {
    RateService.getAllRatesByIdUserAndIsDeleted(getCurrentUserId(), 0).then(
      (result) => {
        console.log("result", result.data["success"]);
        if (result.data["success"]) {
          setAvailableRates(result.data["success"]);
        } else {
          setOpenErrorAlert(true);
          setErrorAlertText("Erreur :erreur serveur ");
        }
      }
    );
    RateService.getAllRatesByIdUserAndIsDeleted(getCurrentUserId(), 1).then(
      (result) => {
        console.log("result", result.data["success"]);
        if (result.data["success"]) {
          setArchivedRates(result.data["success"]);
        } else {
          setOpenErrorAlert(true);
          setErrorAlertText("Erreur :erreur serveur ");
        }
      }
    );
  }, []);

  const onAddRateHandler = () => {
    navigate(`/addTax`);
  };

  const handleEroorClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setOpenErrorAlert(false);
  };
  const handleSuccessClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setOpenSuccessAlert(false);
  };
  const onArchiveHandler = (rateId, isDeleted) => {
    RateService.archiveRateByIdUserAndIsDeleted(
      getCurrentUserId(),
      isDeleted,
      rateId
    ).then((result) => {
      if (result.data["success"]) {
        setOpenSuccessAlert(true);
        if (isDeleted === 1) {
          setSuccessAlertText("Archiver avec succées");
        } else {
          setSuccessAlertText("Restaurer avec succées");
        }
        setTimeout(() => {
          window.location.reload(false);
        }, 2000);
      } else {
        setOpenErrorAlert(true);
        setErrorAlertText("Erreur :erreur serveur ");
      }
    });
  };

  const cardStyle = { borderRadius: 8, boxShadow: "0 1px 6px rgba(0,0,0,.08)" };

  const typeBadge = (rate) => {
    const type = rate.typeTax !== undefined ? rate.typeTax : rate.type;
    if (type === 1) return <span className="badge badge-dark">Taxe</span>;
    if (type === 2)
      return <span className="badge badge-light border">Charge</span>;
    return <span className="text-muted">-</span>;
  };

  const matches = (rate) =>
    `${rate.code || ""} ${rate.name || ""} ${rate.description || ""}`
      .toLowerCase()
      .includes(search.trim().toLowerCase());

  const renderRatesCard = (title, icon, rates, archived) => {
    const list = (rates || []).filter(matches);
    return (
      <div className="card card-outline card-dark mb-4" style={cardStyle}>
        <div className="card-header">
          <h3 className="card-title">
            <i className={`${icon} mr-2`}></i>
            {title}
            <span className="badge badge-dark ml-2">{list.length}</span>
          </h3>
          <div className="card-tools">
            <button
              type="button"
              className="btn btn-tool"
              data-card-widget="collapse"
              title="Réduire"
            >
              <i className="fas fa-minus"></i>
            </button>
          </div>
        </div>
        <div className="card-body p-0 table-responsive">
          <table className="table table-hover table-striped mb-0">
            <thead className="thead-light">
              <tr>
                <th>Type</th>
                <th>Code</th>
                <th>Libellé</th>
                <th>Date de création</th>
                <th>Description</th>
                <th className="text-center">
                  {archived ? "Restaurer" : "Archiver"}
                </th>
              </tr>
            </thead>
            <tbody>
              {list.length === 0 && (
                <tr>
                  <td colSpan={6} className="text-center text-muted py-4">
                    <i className="fas fa-percent fa-2x mb-2 d-block"></i>
                    Aucune taxe trouvée
                  </td>
                </tr>
              )}
              {list.map((element) => (
                <tr key={element.id}>
                  <td>{typeBadge(element)}</td>
                  <td>
                    <span className="badge badge-light border">
                      {element.code}
                    </span>
                  </td>
                  <td>
                    <strong>{element.name}</strong>
                  </td>
                  <td>{UtilsFormule.formatDate(element.creationDate)}</td>
                  <td>{element.description}</td>
                  <td className="text-center">
                    {archived ? (
                      <button
                        type="button"
                        title="Restaurer"
                        className="btn btn-sm btn-outline-info"
                        style={{ width: 36 }}
                        onClick={() => onArchiveHandler(element.id, 0)}
                      >
                        <RestoreFromTrashRoundedIcon fontSize="small" />
                      </button>
                    ) : (
                      <button
                        type="button"
                        title="Archiver"
                        className="btn btn-sm btn-outline-danger"
                        style={{ width: 36 }}
                        onClick={() => onArchiveHandler(element.id, 1)}
                      >
                        <i className="fas fa-trash"></i>
                      </button>
                    )}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    );
  };

  return (
    <div className="content-wrapper" style={{ marginTop: "0" }}>
      <section className="content-header">
        <div className="container-fluid">
          <div className="d-flex flex-wrap justify-content-between align-items-center">
            <div>
              <h4 className="mb-1">
                <i className="fas fa-percent mr-2"></i>Les taxes
              </h4>
              <small className="text-muted">
                Gérez les taxes et les charges appliquées à vos produits
              </small>
            </div>
            <button
              className="btn btn-dark mt-2 mt-sm-0"
              onClick={onAddRateHandler}
            >
              <i className="fas fa-plus mr-1"></i>
              Ajouter une taxe
            </button>
          </div>
        </div>
      </section>

      <section className="content">
        <div className="container-fluid">
          <div className="input-group my-3" style={{ maxWidth: 360 }}>
            <div className="input-group-prepend">
              <span className="input-group-text bg-white">
                <i className="fas fa-search"></i>
              </span>
            </div>
            <input
              type="text"
              className="form-control"
              placeholder="Chercher par code, libellé ou description"
              value={search}
              onChange={(e) => setSearch(e.target.value)}
            />
          </div>

          {renderRatesCard(
            "Les taxes",
            "fas fa-percent",
            availableRates,
            false
          )}
          {renderRatesCard(
            "Les taxes archivées",
            "fas fa-archive",
            archivedRates,
            true
          )}
        </div>
      </section>

      <Snackbar
        open={openErrorAlert}
        autoHideDuration={2000}
        onClose={handleEroorClose}
        anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
      >
        <Alert variant="filled" onClose={handleEroorClose} severity="error">
          {errorAlertText}
        </Alert>
      </Snackbar>
      <Snackbar
        open={openSuccessAlert}
        autoHideDuration={2000}
        onClose={handleSuccessClose}
        anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
      >
        <Alert variant="filled" onClose={handleSuccessClose} severity="success">
          {successAlertText}
        </Alert>
      </Snackbar>
    </div>
  );
};
export default AllRates;
